import * as Yup from "yup";

export const loginschema = Yup.object({
  email: Yup.string().required("Please Enter Email"),
  password: Yup.string().required("Please Enter Password").min(3).max(30),
});

export const signupSchema = Yup.object({
  email: Yup.string()
    .email("Please enter a valid email address")
    .required("Please Enter Email"),
  name: Yup.string()
    .min(2, "Name must be at least 2 characters")
    .required("Please Enter Manager's Name"),
  password: Yup.string()
    .min(6, "Password must be at least 6 characters")
    .required("Please Enter Password"),
  confirmPassword: Yup.string()
    .oneOf([Yup.ref('password'), null], "Passwords must match")
    .required("Please Confirm Password"),
});

export const createAccountSchema = Yup.object({
  email: Yup.string()
    .email("Please enter a valid email address")
    .required("Please Enter Email"),
  password: Yup.string()
    .min(8, "Password must be at least 8 characters")
    .matches(/[0-9]/, "Password must contain at least 1 number")
    .matches(/[!@#$%^&*(),.?":{}|<>]/, "Password must contain at least 1 special character")
    .required("Please Enter Password"),
  confirmPassword: Yup.string()
    .oneOf([Yup.ref('password'), null], "Passwords must match")
    .required("Please Confirm Password"),
  otp: Yup.string()
    .matches(/^\d{6}$/, "OTP must be exactly 6 digits")
    .required("Please Enter OTP"),
});
